import {
  MdOutlineCameraEnhance,
  MdOutlineAddToHomeScreen,
} from "@onemind-services-llc/react-icons-ng/md";
import { LuScaling } from "@onemind-services-llc/react-icons-ng/lu";

export const ADVANTAGES_CONSTANTS = [
  {
    icon: MdOutlineAddToHomeScreen,
    title: "Optimized Traffic Distribution",
    text: "Efficiently manages incoming traffic to prevent server overloads.",
  },
  {
    icon: MdOutlineCameraEnhance,
    title: "Enhanced Application Availability",
    text: "Minimizes downtime by rerouting traffic during server failures.",
  },
  {
    icon: LuScaling,
    title: "Scalable Infrastructure",
    text: "Easily adapts to increasing traffic demands without compromising performance.",
  },
];
